import { Koi } from '@ksyos/koi';
import { Profession } from '@common/enums';
import type { ISchemaContainer } from './schemaContainer';

export type BackendBrightPlanScheduleAction = {
    cancellationReason?: string;
    creatorPractitionerId: string;
    description: string;
    endDate: string;
    episodeCategoryId: string;
    fundusPatientId?: string;
    locationTypeIds: number[];
    operationTypeIds: string[];
    performerOrganizationId: string;
    performerProfession: Profession;
    poliFollowUpDate: string;
    processId?: string;
    professionalIds: string[];
    recipientPractitionerId?: string;
    requestId?: string;
    startDate: string;
    title: string;
};

export const backendBrightPlanScheduleActionValidator = Koi.object({
    cancellationReason: Koi.string().max(500).optional(),
    creatorPractitionerId: Koi.string().uuid().required(),
    description: Koi.string().max(500).allow(null),
    endDate: Koi.koi().date().required().endDate(),
    episodeCategoryId: Koi.string().uuid().required(),
    fundusPatientId: Koi.string().uuid().optional(),
    locationTypeIds: Koi.array().items(Koi.number()).min(1).required(),
    operationTypeIds: Koi.array().items(Koi.string()).min(1).required(),
    performerOrganizationId: Koi.string().uuid().required(),
    performerProfession: Koi.koi().enum(Profession).required(),
    poliFollowUpDate: Koi.koi().date().required(),
    processId: Koi.string().uuid().optional(),
    professionalIds: Koi.array().items(Koi.string()).min(1).required(),
    recipientPractitionerId: Koi.string().uuid().optional(),
    requestId: Koi.string().uuid().optional(),
    startDate: Koi.koi().date().required(),
    title: Koi.string().max(50).required(),
});

export const BrightPlanScheduleActionSchema: ISchemaContainer<BackendBrightPlanScheduleAction> = {
    schema: backendBrightPlanScheduleActionValidator.options({ convert: false, presence: 'required' }),
};
